// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__DKUYU","label":"CategoryService_label__1UNtX","location":"CategoryService_location__25rRw"};